import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Embeddedbi from '../../Services/Embeddedbi';
import { useUser } from '../../User';
import { buildReportsCsv, downloadCsv } from '../../Utility/CsvExport';

interface Props {
  setPageTitle: (title: string) => void;
}

type ExportState = 'loading' | 'success' | 'error';

export default function AdminExport({ setPageTitle }: Props) {
  const { user } = useUser();
  const navigate = useNavigate();
  const [exportState, setExportState] = useState<ExportState>('loading');

  useEffect(() => {
    setPageTitle('Export Reports');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!user?.isAdmin) {
      navigate('/');
      return;
    }

    const filename = `ebi-reports-${new Date().toISOString().split('T')[0]}.csv`;

    Embeddedbi.getAllCategories()
      .then(categories => {
        const csv = buildReportsCsv(categories);
        downloadCsv(csv, filename);
        setExportState('success');
      })
      .catch(() => setExportState('error'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (exportState === 'loading') {
    return <div className="adminExport">Generating export...</div>;
  }

  if (exportState === 'error') {
    return <div className="adminExport adminExport--error">Failed to generate export. Please try again.</div>;
  }

  return <div className="adminExport adminExport--success">Export complete. Your download has started.</div>;
}
